import script from "./SupplyData.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplyData.vue?vue&type=script&setup=true&lang=js"

import "./SupplyData.vue?vue&type=style&index=0&id=1f851f0a&lang=scss"

const __exports__ = script;

export default __exports__